/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WarningXsmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WarningXsmall',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 10 * scale,
      viewBox: '0 0 13 10',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M11.218 7.72 7.282 1.28c-.43-.704-1.134-.704-1.564 0L1.782 7.72C1.352 8.424 1.675 9 2.5 9h8c.825 0 1.148-.576.718-1.28M7 8H6V7h1zm0-2H6V3h1z"}))
}
